function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9351 2.07428L12.9351 25.7959",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.2603 14.9417L12.8811 25.7952",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6098 14.9417L12.8812 25.7953",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.629 14.9057L32.6113 14.8985C32.419 14.8985 32.224 14.9173 32.0353 14.8914C31.4664 14.8118 30.9852 14.589 31.0004 13.92C31.0147 13.251 31.4816 13.0238 32.0764 13.022C34.2159 13.014 32.6864 13.014 33.775 13.022C39.0387 13.0229 44.3041 13.0301 49.5678 13.0238C51.244 13.0211 52.447 11.8333 52.4264 10.2475C52.4076 8.75116 51.2001 7.56963 49.6939 7.5741C48.1797 7.57857 46.9749 8.83971 47.0205 10.3772C47.0268 10.5686 47.0643 10.7591 47.0777 10.9505C47.1189 11.5346 46.8917 11.9505 46.2844 12.0391C45.6744 12.1276 45.3148 11.7806 45.2138 11.2153C45.0313 10.201 45.1127 9.2091 45.5876 8.26817C46.5956 6.27719 48.7458 5.29333 50.9077 5.84519C52.9872 6.37558 54.3753 8.29232 54.3011 10.5293C54.2313 12.658 52.6902 14.4665 50.5105 14.7912C49.3809 14.9602 48.2154 14.9182 47.0661 14.9245C44.254 14.9414 41.4411 14.9298 38.629 14.9298V14.9057Z",
  fill: "#F0F0F5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5342 17.2116C41.128 17.2116 43.7227 17.2125 46.3165 17.2107C48.057 17.2107 49.5158 18.4405 49.6581 20.063C49.836 22.1067 48.7386 23.3312 46.9229 23.6863C45.2083 24.0208 43.6377 22.9073 43.2871 21.1935C43.1807 20.6703 43.3676 20.2875 43.8703 20.1122C44.3711 19.9378 44.762 20.1265 45.0241 20.5782C45.084 20.681 45.1153 20.8 45.1609 20.91C45.4623 21.6318 45.999 21.9359 46.6841 21.774C47.4256 21.5978 47.8576 21.0263 47.786 20.3152C47.7172 19.6256 47.1653 19.1185 46.4051 19.1131C44.0992 19.0988 41.7934 19.1069 39.4876 19.1069C36.5351 19.1078 35.5398 19.0818 32.5882 19.0818C32.4433 19.0818 32.2984 19.0908 32.1562 19.0738C31.5971 19.0085 31.1902 18.75 31.1481 18.1436C31.1133 17.6329 31.573 17.2196 32.2107 17.2116C33.7938 17.1937 33.4199 17.2304 35.003 17.2295C36.18 17.2286 37.3571 17.2286 38.5342 17.2286V17.2116Z",
  fill: "#F0F0F5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.1171 10.7488C33.5564 10.7488 33.9511 10.7557 32.3912 10.7459C31.6256 10.7414 31.1524 10.3863 31.1399 9.84698C31.1265 9.27007 31.6184 8.87564 32.4073 8.87385C35.4331 8.86937 36.5035 8.8777 39.5293 8.87323C40.3495 8.87144 40.9327 8.38667 41.0015 7.68902C41.0713 6.98779 40.6232 6.35812 39.93 6.18371C39.2574 6.01466 38.6465 6.37869 38.3263 7.18457C38.0991 7.75521 37.7441 8.06199 37.1144 7.87506C36.5285 7.70065 36.3344 7.17383 36.5679 6.46008C36.9587 5.25977 38.1537 4.3421 39.4229 4.26607C40.7779 4.18557 42.0605 4.95567 42.6052 6.17924C43.5703 8.34731 42.0453 10.7256 39.6581 10.7515C38.1448 10.7685 36.6305 10.7551 35.1171 10.7551V10.7488Z",
  fill: "#F0F0F5"
});

function SvgWindN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 28,
    viewBox: "0 0 55 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindN);
export default __webpack_public_path__ + "static/media/wind-N.dc7237c8.svg";
export { ForwardRef as ReactComponent };